import { createContext } from "react";

// True when the consumer is rendered directly against the viewport edge
// (e.g. inside a fullBleed Page) and should apply the page gutter (24px)
// to its outer-most content rather than relying on a parent's padding.
// Panel resets this to false because Panel introduces its own internal gutter.
export const PageEdgeContext = createContext(false);
